import { Signal } from "signals";
import AutoplayOptions from "slotworks/components/betbar/vo/autoplay-options";
import betModel from "slotworks/model/bets/bet-model";
import wrapperMediator from "slotworks/integration/revolver/wrapper/wrapper-mediator";

class AutoplayModel {

    public onDecrease: Signal;

    public autoplaySteps: number[];
    public maxAutoplays: number = 100;
    public defaultAutoplays: number = 0;

    public singleWinLimit: number = 0;
    public totalWinLimit: number = 0;
    public lossLimit: number = 0;
    public stopOnFeatureWin: boolean = false;
    public stopOnAnyWin: boolean = false;

    public stopOnAnyBonusExit: boolean = false;

    public runningWinLoss: number = 0;

    private autoplays: number = 0;

    private playForever: boolean;

    private startConfirmed: boolean;

    public autoplayDisabled: boolean = false;

    private initialLossLimitMultiplier: number = 60;

    constructor() {
        this.onDecrease = new Signal();
    }

    public confirm() {
        this.autoplays--;
        this.runningWinLoss = 0;
        this.startConfirmed = true;

        wrapperMediator.autoplayStart();
    }

    public setAutoplays(autoplays: number) {
        if (autoplays < 0) {
            this.autoplays = 0;
            this.playForever = true;
        } else {
            this.playForever = false;
            this.autoplays = autoplays;
        }
    }

    public getAutoplays(): number {
        return this.autoplays;
    }

    public isAutoPlaying(): boolean {
        return (this.autoplays > 0 || this.playForever) && this.startConfirmed;
    }

    public decrease() {
        if (!this.playForever) {
            this.autoplays--;

            if (this.autoplays <= 0) {
                this.stop();
            }

            this.onDecrease.dispatch();
        }
    }

    public stop() {
        this.autoplays = this.defaultAutoplays;
        this.startConfirmed = false;

        wrapperMediator.autoplayEnd();
    }

    public generateAutoplayOptions(): AutoplayOptions {
        const autoplayOptions = new AutoplayOptions();

        autoplayOptions.autoplays = this.getAutoplays();
        autoplayOptions.maxAutoplays = this.maxAutoplays;
        if (!this.autoplaySteps) {
            this.autoplaySteps = [];
            for (let i = 0; i <= this.maxAutoplays; i++) {
                this.autoplaySteps.push(i);
            }
        }

        autoplayOptions.autoplaySteps = this.autoplaySteps;
        autoplayOptions.defaultAutoplayStep = this.defaultAutoplays;

        autoplayOptions.lossLimit = this.lossLimit || this.getInitialLossLimit();
        autoplayOptions.singleWinLimit = this.singleWinLimit;
        autoplayOptions.totalWinLimit = this.totalWinLimit;
        autoplayOptions.stopOnFeatureWin = this.stopOnFeatureWin;
        autoplayOptions.stopOnAnyWin = this.stopOnAnyWin;

        return autoplayOptions;
    }

    public updateFromOptions(options: AutoplayOptions) {
        this.setAutoplays(options.autoplays);

        this.lossLimit = options.lossLimit;
        this.singleWinLimit = options.singleWinLimit;
        this.totalWinLimit = options.totalWinLimit;
        this.stopOnFeatureWin = options.stopOnFeatureWin;
        this.stopOnAnyWin = options.stopOnAnyWin;
    }

    public getInitialLossLimit() {
        return betModel.getTotalBet() * this.initialLossLimitMultiplier;
    }

}

export default new AutoplayModel();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/autoplay-model.ts